module.exports = __webpack_public_path__ + "img/join-bemovin-bg.b13b0b52.webp";